import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SdsTableSectionAccordion',
  props: {
  isShow: {
    type: Boolean,
    default: true,
  },
  initialClosed: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;



const isClosed = ref(props.initialClosed);

watch(
  () => props.initialClosed,
  (newValue) => {
    isClosed.value = newValue;
  }
);

const toggleSection = () => {
  isClosed.value = !isClosed.value;
};

return { __sfc: true,props, isClosed, toggleSection }
}

})